// extracted by mini-css-extract-plugin
module.exports = {"header":"doctrine-unlogged-lock-content_header__WmGQa","card":"doctrine-unlogged-lock-content_card__RRmWr","buttons":"doctrine-unlogged-lock-content_buttons__IW_R_"};